import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";

@Injectable({
    providedIn: 'root'
})

export class H2GlobalSteamReformerService {

    constructor(protected http: HttpClient) {

    }

    baseurl = environment.apiBaseUrl + 'SMRAndASUAwards/getallsmrawards';

    getReportData() {
        return this.http.get<any[]>(this.baseurl);
    }

}